import dynaForms from '@elab/core/utils/dynaForms';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import getTypes from './types';

export const initialState = (state, initialData) => ({
    ...dynaInitialState(state),
    ...initialData,
    cardInfo: {},
    cardType: 0,
    giftCards: [],
    isPayment: false,
    isBalanceCheck: false,
    isVoucher: false,
    couponValidationPattern: '',
    couponErrorText: '',
    isCouponValidationEnabled: false,
    scrollToError: false,
    errors: {},
    active: false,
    cardsWithError: [],
    validationParams: {},
    giftCardCodeToBeDeleted: '',
});

const getReducers = storeName => {
    const dynaFormReduce = dynaForms.createReducer(storeName);
    const types = getTypes(storeName);

    return (state = initialState(), action) => {
        state = dynaFormReduce(state, action);
        const { payload } = action;

        switch (action.type) {
            case types.SET_CARD_INFO:
                return reduceAction(state, 'cardInfo', payload);

            case types.SET_GIFT_CARDS:
                return { ...state, giftCards: [...payload] };

            case types.SET_PROPERTIES:
                return {
                    ...state,
                    isPayment: payload.isPayment,
                    isBalanceCheck: payload.isBalanceCheck,
                    isVoucher: payload.isVoucher,
                    isCouponValidationEnabled: payload.isCouponValidationEnabled,
                    couponValidationPattern: payload.couponValidationPattern,
                    couponErrorText: payload.couponErrorText,
                    scrollToError: payload.scrollToError,
                };

            case types.SET_ERRORS_DETAILS:
                return reduceAction(state, 'errors', payload);

            case types.TOGGLE_FIELD_VALUE:
                return reduceAction(state, payload.name, payload.value);

            case types.SET_CARDS_WITH_ERROR:
                return { ...state, cardsWithError: [...payload] };

            case types.SET_VALIDATION_PARAMS:
                return reduceAction(state, 'validationParams', payload);

            case types.SET_GIFT_CARD_CODE_TO_BE_DELETED:
                return reduceAction(state, 'giftCardCodeToBeDeleted', payload);

            case types.SET_GIFT_CARD_TYPE:
                return reduceAction(state, 'cardType', payload);

            case types.SET_IS_BALANCE_CHECK:
                return reduceAction(state, 'isBalanceCheck', payload);

            default:
                return state;
        }
    };
};

export default getReducers;
